export default __webpack_public_path__ + "static/media/eyes.0b883021.svg";